import "./App.css";
import RouterPage from "./RouterPages/RouterPage";
import Navbar from "./component/Navbar/Navbar";
import Footer from "./component/Footer/Footer";
import { Hide } from "@chakra-ui/react";
import { useMatch } from 'react-router-dom';
import { Box } from "@chakra-ui/react"

import { useDispatch, useSelector } from "react-redux";
import { fetchProductAsync, selectProduct } from "./features/Product/ProductSlice";
import { useEffect } from "react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  fetchSelectedAddressAsync,
  fetchUserAsync,
  fetchUserProfileAsync,
  getDeliveryAddressrAsync,
  loginUserSelector,
} from "./features/User/UserSlice";
import BottomNav from "./component/Navbar/BottomNav";

function App() {
  const match = useMatch("/productdetailpage/:id");
  const loginUser = useSelector(loginUserSelector);
  const product = useSelector(selectProduct);

  const dispatch = useDispatch();
  useEffect(() => {
    if (product?.status !== 1) {
      dispatch(fetchProductAsync(1));
      localStorage.setItem("basicpage", 2);
    }


    dispatch(fetchUserProfileAsync());
  }, []);

  useEffect(() => {
    if (loginUser?.status === 1) {
      dispatch(fetchUserAsync({ id: loginUser.data.user_id }));
      dispatch(getDeliveryAddressrAsync({ id: loginUser.data.user_id }));
      dispatch(fetchSelectedAddressAsync({ id: loginUser.data.user_id }));
    }
  }, [loginUser,dispatch]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
      <Navbar />
      <RouterPage />
      <Footer />
      <Hide above="md">
        {match && <Box bg="white" h="50px"></Box>}
        <BottomNav />
      </Hide>
    </GoogleOAuthProvider>
  );
}

export default App;
